<template>
  <div>
    <Nav title="往期中奖名单" />
    <div class="paseWinners_list_bg">
      <div
        class="paseWinners_item_bg"
        v-for="(value, index) in datas"
        :key="index"
      >
        <prize
          class="paseWinners_item_prize"
          :prizeIndex="value.num.toString()"
          :prizeName="value.award.name"
          :prizePrice="value.award.price.toString()"
          :prizeImage="value.award.picture"
        />
        <div class="paseWinners_item_title">
          {{ lotteryTimerFormatter(index) }} 开奖
        </div>
        <div class="paseWinners_item_content ">
          <div class="paseWinners_item_not_draw" v-if="!isDraw">
            因活动参与人数过少，取消开奖
          </div>
          <div class="paseWinners_item_draw" v-if="isDraw">
            <div class="paseWinners_item_draw_name">中奖用户</div>
            <div class="paseWinners_item_draw_phone">
              {{ value.winner.userName }}
            </div>
            <div class="paseWinners_item_draw_code">
              {{ value.winner.luckyCode }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import Nav from "../../components/nav/Nav.vue";
import Prize from "../../components/lottery/Prize.vue";
import { Urls } from "../../net/Urls";
import { Http, ResponseData } from "../../net/Http";
import { Phases } from "../../model/lottery/LotteryModel";
import { TimerFormatter } from "../../hooks/TimerFormatter";

@Options({
  components: {
    Nav,
    Prize
  }
})
export default class PaseWinnersList extends Vue {
  datas: Phases[] = [];
  //是否开奖品
  isDraw = true;
  mounted() {
    this.initData();
  }
  initData() {
    Http.get<Phases[]>(Urls.lottery_phases).then(
      (res: Phases[]) => {
        this.datas = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_phases, err.message);
        // openToast(err.message);
      }
    );
  }
  lotteryTimerFormatter(index: number) {
    return TimerFormatter.lotteryTimerFormatter(
      this.datas[index].drawTime.toString()
    );
  }
}
</script>

<style lang="less">
.paseWinners_list_bg {
  background-color: #f6f6f6;
  width: 100%;
  position: fixed;
  margin: 0 auto;
  left: 0px;
  bottom: 0px;
  top: 44px;
  overflow-y: scroll;
  .paseWinners_item_bg {
    background-color: white;
    border-radius: 0px 0px 10px 10px;
    padding-bottom: 17px;
    padding-top: 1px;
    margin-bottom: 10px;
    .paseWinners_item_prize {
      margin-top: 20px;
    }
    .paseWinners_item_title {
      text-align: left;
      margin: 17px 20px 0px 20px;
      font-size: 13px;
      color: #888888;
    }

    .paseWinners_item_content {
      background-color: #f6f6f6;
      border-radius: 10px;
      height: 44px;
      text-align: left;
      line-height: 44px;
      padding-left: 10px;
      padding-right: 10px;
      margin: 10px 20px 0px 20px;
    }
    ///取消开奖
    .paseWinners_item_not_draw {
      font-size: 13px;
      color: #111111;
    }
    /// 开奖
    .paseWinners_item_draw {
      font-size: 13px;
      color: #111111;
      .paseWinners_item_draw_name {
        float: left;
        font-size: 14px;
        font-weight: bold;
        color: #ff1e1e;
      }
      .paseWinners_item_draw_phone {
        float: left;
        padding-left: 16px;
        font-size: 14px;
        font-weight: bold;
        max-width: 55%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .paseWinners_item_draw_code {
        float: left;
        padding-left: 16px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
